.fk{border:1px solid #ddd;}